// @flow
import { createReducer } from 'redux-act';

import type { AlteredSearch, Search as State } from '../../types';
import {
  set,
  setLoading,
  setError,
  setFirstResultLoading,
  setFilterFailed,
  setAlteredSearch,
  setRequiredAvailables,
  setSearchUUID,
  reset,
} from '../actions/search';

const MIN_SUGGESTION = 15;

const initialState: State = {
  value: '',
  loading: false,
  firstResultLoading: false,
  error: false,
  filterFailed: false,
  alteredSearch: false,
  requiredAvailables: MIN_SUGGESTION,
};

function setHandler(state: State, input: string): State {
  const value = input
    .toLowerCase()
    .replace(/\s/g, ' ')
    .trim()
    .split(',')
    .join(' ');

  if (value === state.value) {
    return state;
  }

  return {
    ...state,
    value,
  };
}

function setLoadingHandler(state: State, loading: boolean): State {
  return {
    ...state,
    loading,
  };
}

function setFirstResultLoadingHandler(
  state: State,
  firstResultLoading: boolean,
): State {
  return {
    ...state,
    firstResultLoading,
  };
}

function setErrorHandler(state: State, error: boolean): State {
  return {
    ...state,
    error,
  };
}

function setFilterFailedHandler(state: State, filterFailed: boolean): State {
  if (state.filterFailed === filterFailed) {
    return state;
  }

  return {
    ...state,
    filterFailed,
  };
}

function setAlteredSearchHandler(
  state: State,
  alteredSearch: AlteredSearch,
): State {
  return {
    ...state,
    alteredSearch,
  };
}

function setRequiredAvailablesHandler(
  state: State,
  requiredAvailables: number,
): State {
  return {
    ...state,
    requiredAvailables,
  };
}

function setSearchUUIDHandler(state: State, searchUUID: string): State {
  return {
    ...state,
    searchUUID,
  };
}

function resetHandler(): State {
  return initialState;
}

export default (createReducer(
  {
    [set.toString()]: setHandler,
    // $FlowFixMe[incompatible-type] TODO: fix type
    [setLoading.toString()]: setLoadingHandler,
    // $FlowFixMe[incompatible-type] TODO: fix type
    [setFirstResultLoading.toString()]: setFirstResultLoadingHandler,
    // $FlowFixMe[incompatible-type] TODO: fix type
    [setError.toString()]: setErrorHandler,
    // $FlowFixMe[incompatible-type] TODO: fix type
    [setFilterFailed.toString()]: setFilterFailedHandler,
    // $FlowFixMe[incompatible-type] TODO: fix type
    [setAlteredSearch.toString()]: setAlteredSearchHandler,
    // $FlowFixMe[incompatible-type] TODO: fix type
    [setRequiredAvailables.toString()]: setRequiredAvailablesHandler,
    [setSearchUUID.toString()]: setSearchUUIDHandler,
    [reset.toString()]: resetHandler,
  },
  initialState,
): {
  (): (state: State, payload?: mixed, meta?: mixed) => State,
  assignAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  batch: ({ ... } | Array<mixed>) => mixed,
  bindAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  disbatch: (mixed, void | Array<mixed>) => mixed,
  has: (actionCreator: mixed) => boolean,
  // $FlowFixMe[cannot-resolve-name]
  off: Reducer$Off,
  // $FlowFixMe[cannot-resolve-name]
  on: Reducer$On<State>,
  options: () => mixed,
  ...
});
